import {css} from 'aphrodite/no-important';
import React from 'react';
import {styles} from '../styles/FsModalStyles';

/* https://www.w3schools.com/howto/howto_css_modals.asp
*
* {duration}: should be in milliseconds.
* {cookieExpirationInDays}: specify in hours.
* */
class FsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            styles: this.props.styles ? this.props.styles : styles,
            showModal: this.props.showModal || false,
            content: this.props.content || '--- NO CONENT SET ---',
            duration: this.props.duration || 0,
            bodyClassName: this.props.bodyClassName  || 'sitewide-modal-open'
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.timerRef = null;
        
    };

    componentDidMount() {
        if(this.state.showModal) {
            this.openModal();
        }
    }

    render() {
        if (!this.state.showModal) {
            return null;
        }

        return (
            <div className={css(this.state.styles.modal)}>
                <div className={css(this.state.styles.modalContent)}>
                    <span className={css(this.state.styles.close)} onClick={this.closeModal}>&times;</span>
                    {this.state.content}
                </div>
            </div>
        )
    }

    openModal() {
        this.setState({showModal: true});
        this.startTimer();
        document.body.classList.add(this.state.bodyClassName);
    }

    closeModal() {
        this.setState({showModal: false});
        clearTimeout(this.timerRef);
        document.body.classList.remove(this.state.bodyClassName);
    }

    startTimer() {
        if (this.state.duration > 0) {
            this.timerRef = setTimeout(this.closeModal, this.state.duration);
        }
    }
}

export default FsModal;



// WEBPACK FOOTER //
// ./react-app-src/shared/components/FsModal.js